import React from 'react';
import styled from 'styled-components';
import InputLabel from '../inputLabel/InputLabel';
import { ThemeColors } from '../../themes/online';

// ############################ Styles ###########################
// tslint:disable:variable-name

const SInputGroup = styled.section<{}>(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  margin-bottom: ${theme.spacing.large}px;
  position: relative;
`
);

const SInputGroupInner = styled.section<{ gaps: number }>(
  ({ theme, gaps }) => `
  display: flex;
  flex-direction: column;
  .inputInGroup:not(:nth-last-child(-n+${1 + gaps})) {
    margin-bottom: ${theme.spacing.large}px;
  }
  @media only screen and (min-width: 800px) {
    flex-direction: row;
    justify-content: space-between;
    .inputInGroup:not(:nth-last-child(-n+${1 + gaps})) {
      margin-bottom: 0;
      margin-right: 3%;
    }
  }
`
);

const SInputGap = styled.div(() => ({
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: 0,
}));

// tslint:enable:variable-name
// ############################ End Styles ###########################

interface IInputGroupProps {
  dataAt: string;
  label?: string | React.ReactChild;
  addGap?: number;
  className?: string;
  inputId?: string;
  labelColor?: ThemeColors;
}

// tslint:disable-next-line:variable-name
const InputGroup: React.FC<IInputGroupProps> = (props) => {
  const gapElements = [];
  if (props.addGap) {
    for (let i = 0; i < props.addGap; i++) {
      gapElements.push(<SInputGap key={`gap_${i}`} className="inputInGroup" />);
    }
  }

  return (
    <SInputGroup className={props.className}>
      {props.label && (
        <InputLabel color={props.labelColor} inputId={props.inputId} dataAt={`${props.dataAt}-label`}>
          {props.label}
        </InputLabel>
      )}
      <SInputGroupInner data-at={props.dataAt} gaps={props.addGap || 0}>
        {props.children}
        {gapElements}
      </SInputGroupInner>
    </SInputGroup>
  );
};

export default InputGroup;
